export default {"src":"/_next/static/media/agricultural-land-icon-selected.8f049e7d.svg","height":87,"width":108,"blurWidth":0,"blurHeight":0};